import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  LIST_PADDING,
  LIST_TOP_MARGIN,
  MAX_CONTENT_HEIGHT,
  MAX_MOBILE_CONTENT_HEIGHT,
  SAFE_LIST_AREA_HEIGHT,
  SEARCH_FIELD_BOX_HEIGHT,
  SEARCH_FIELD_BOX_PADDING,
  TABS_HEAIGHT,
} from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programCollectionListWrapper: {},
  programCollectionListSearch: {
    marginTop: SEARCH_FIELD_BOX_PADDING,
  },
  programCollectionListContainer: {
    position: 'relative',
    paddingTop: LIST_PADDING,
    paddingBottom: LIST_PADDING,
    marginTop: LIST_TOP_MARGIN,
    borderTop: `1px solid ${theme.palette.paper.borderColor}`,
    maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
    height: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
    overflowY: 'auto',

    [theme.breakpoints.down('md')]: {
      maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
      height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
    },
  },
  programCollectionListHeader: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
  programCollectionListContainerWithAddButton: {
    position: 'relative',
    paddingTop: LIST_PADDING,
    paddingBottom: LIST_PADDING,
    marginTop: LIST_TOP_MARGIN,
    borderTop: `1px solid ${theme.palette.paper.borderColor}`,
    maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
    height: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
    overflowY: 'auto',

    [theme.breakpoints.down('md')]: {
      maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
      height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${SEARCH_FIELD_BOX_HEIGHT} - ${LIST_TOP_MARGIN})`,
    },
  },
}));
